<template>
<div>
  <!--    Breadcrumbs-->
  <breadcrumb style="margin-left: -15px">
    <breadcrumb-item>
      <a href="/settings/company">Company settings</a>
    </breadcrumb-item>
    <breadcrumb-item>
      <span>Data migration</span>
    </breadcrumb-item>
  </breadcrumb>
  <!--    Loader-->
  <loading-panel :loading="loading"></loading-panel>

  <div class="row">
    <div class="col">
      <card>
        <div class="row mb-2">
          <div class="col">
            <tab-rail
              :tabs="categories"
              :value="activeTabIndex"
              @input="switchTab"
            />
          </div>
        </div>

        <div v-if="activeTabIndex === 0">

          <div class="row mb-2">
            <div class="col-lg-7">
              <div v-show="!isOTC()">
                <base-alert type="primary">
                  <i class="tim-icons icon-alert-circle-exc mr-2"></i>
                  Currently Migrations can only be performed by Off The Couch Administrators.<br/>
                  Please contact Nick at nick@offthecouch.io or on Discord to schedule your migration.
                  In preparation please look at Migration Advice to the right and
                  the Migration Types below to prepare reports in advance.
                </base-alert>
              </div>
              <div class="row mt-3" >
                <div class="col-lg-6">
                  <base-input label="Type" :error="errs.type">
                    <el-select
                      v-model="selectedMigrationType"
                      class="select-primary"
                      placeholder="Select type"
                      value-key="id"
                      v-on:input="setFields()"
                    >
                      <el-option
                        v-for="(m, i) in migration_types"
                        class="select-primary"
                        :label="m.name"
                        :value="{name: m.name, id: m.id}"
                        :key="'M' + i"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>
              </div>
              <div class="row" v-if="selectedMigrationType">
                <div class="col-lg-10">
                  <label>
                    <div>Fields
                      <el-popover trigger="hover"
                                  placement="right">

                        <div>
                          <div class="popover-body"><small>Upload a csv file with the following column names included.<br/>
                            Mandatory fields are marked with an asterisk.</small></div>
                        </div>
                        <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                      </el-popover>
                    </div>
                  </label>
                  <base-alert type="secondary" style="margin-bottom: 2px">
                    <div class="row">
                      <div class="col-lg-11">
                        <code v-html="fields">
                        </code>
                      </div>
                      <div class="col-lg-1 text-right">
                        <el-tooltip content="Copy"
                                    effect="light"
                                    :open-delay="300"
                                    placement="top">
                          <i style="cursor:pointer;" v-on:click="copy()" class="tim-icons text-default icon-single-copy-04"></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </base-alert>
                  <b-table :fields="['report_best_practices']" :items="report_best_practices">
                    <template v-slot:cell(report_best_practices)="row">
                      <div class="row">
                        <div class="col-1" style="padding-right: 0">
                          {{row.item.id}}
                        </div>
                        <div class="col" style="padding-left: 0">
                          {{row.item.text}}
                          <a v-if="row.item.download" href="#" @click.prevent="downloadCountryCodes()" style="margin-left: 4px">
                            <i class="tim-icons icon-cloud-download-93 mr-1"></i>Download reference
                          </a>
                        </div>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row" :key="j" v-show="isOTC()">
                <div class="col">
                  <span class="btn btn-primary btn-file mt-3"><i class="tim-icons icon-upload"></i> Upload data file
                    <input type="file"
                           accept=".csv"
                           @change="uploadFile"

                    />
                  </span>
                </div>
              </div>

            </div>
            <div class="col-lg-5">
              <div style="border: 1px solid white; padding-bottom: 15px; padding-left: 20px; padding-right: 30px; padding-top: 5px; border-radius: 3px">
                <div class="col">
                  <b-table :fields="['migration_advice']" :items="migration_advice">
                    <template v-slot:cell(migration_advice)="row">
                      <div class="row">
                        <div class="col-1" style="padding-right: 0">
                          {{row.item.id}}
                        </div>
                        <div class="col" style="padding-left: 0">
                          {{row.item.text}}
                        </div>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="activeTabIndex === 1">
          <filter-bar
            :filters="filterSchema"
            :initial-value="filterValues"
            :result-count="totalRows"
            :per-page="perPage"
            :per-page-options="perPageOptions"
            saved-filters-key="migration-logs"
            @change="onFiltersChanged"
            @update:perPage="onPerPageChange"
          >
            <template #actions>
              <base-button v-if="migration_log.length > 0" icon class="btn-link text-white" v-on:click="downloadLogsCSV()">
                <i class="tim-icons icon-cloud-download-93"></i>
              </base-button>
            </template>
          </filter-bar>
          <div class="mt-3" v-if="migration_log.length <= 0">
            <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <h4 class="mt-3">No data has been uploaded yet.</h4>
            </div>
          </div>
          <div class="d-sm-block d-none">
            <div class="row" v-if="migration_log.length > 0">
              <div class="col">
                <b-table :items="migration_log"
                         :fields="['upload_type', 'uploaded_by', 'status', 'records_imported', 'failed_record_count', 'duplicate_count', 'actions']">
                  <template v-slot:cell(upload_type)="row">
                    <badge>{{row.item.type}}</badge>
                  </template>
                  <template v-slot:cell(status)="row">
                    <badge :type="statusBadgeType(row.item)">{{ statusLabel(row.item) }}</badge>
                  </template>
                  <template v-slot:cell(records_imported)="row">
                    <div v-if="row.item.purged">-</div>
                    <div v-else>
                      <div>{{row.item.number_of_records}} / {{row.item.total_rows}}</div>
                      <div v-if="isRunning(row.item)" class="d-flex align-items-center mt-1" style="gap: 8px; max-width: 220px">
                        <el-progress class="flex-grow-1" :percentage="batchPercent(row.item)" :show-text="false" :stroke-width="6" color="#e14eca" />
                        <small class="text-muted text-nowrap">batch {{ Math.min(row.item.completed_batch_count + 1, row.item.batch_count) }} of {{ row.item.batch_count }}</small>
                      </div>
                    </div>
                  </template>
                  <template v-slot:cell(failed_record_count)="row">
                    {{row.item.failed_record_count || 0}}
                    <!--                    <span v-if="row.item.batch_count === row.item.completed_batch_count">{{row.item.total_rows - row.item.number_of_records}}</span>-->
                    <!--                    <span v-else>-</span>-->
                  </template>
                  <template v-slot:cell(duplicate_count)="row">
                    {{row.item.duplicate_record_count}}
<!--                    <span v-if="row.item.batch_count === row.item.completed_batch_count">{{row.item.total_rows - row.item.number_of_records}}</span>-->
<!--                    <span v-else>-</span>-->
                  </template>
                  <template v-slot:cell(uploaded_by)="row">
                    <p>{{row.item.first_name}} {{row.item.last_name}}</p>
                    <small style="font-style: italic">
                      {{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}
                    </small>
                  </template>

                  <template v-slot:cell(actions)="row">
                    <div v-if="row.item.purged || isPurging(row.item)">-</div>
                    <el-dropdown v-if="!row.item.purged && !isPurging(row.item)">
                      <base-button
                        simple
                        type="primary"
                        link
                      > <i style="font-size: medium" class="tim-icons el-icon-more"></i>
                      </base-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <a class="dropdown-item mb-2 py-1" v-if="canCancel(row.item)" href="#" @click.prevent="cancelRunPrompt(row.item)">
                            <i class="tim-icons icon-simple-remove mr-2"></i> Cancel run
                          </a>
                          <a class="dropdown-item mb-2 py-1" v-if="!row.item.purged" href="#" @click.prevent="viewRecords(row.item)">
                            <i class="tim-icons icon-notes mr-2"></i> View records
                          </a>
                          <a class="dropdown-item mb-2 py-1" v-if="row.item.duplicate_record_count > 0" href="#" @click.prevent="viewDuplicateRecords(row.item)">
                            <i class="tim-icons icon-single-copy-04 mr-2"></i> View duplicates
                          </a>
                          <a class="dropdown-item mb-2 py-1" v-if="row.item.failed_migration_records" href="#" @click.prevent="downloadErrorRecords(row.item.failed_migration_records)">
                            <i class="tim-icons icon-cloud-download-93 mr-2"></i> Download error records
                          </a>
                          <hr v-if="!row.item.purged && !isRunning(row.item) && hasPermissions('migrations_delete')">
                          <a v-if="!row.item.purged && !isRunning(row.item) && hasPermissions('migrations_delete')"
                            class="dropdown-item" @click.prevent="deleteRecordsPrompt(row.item)" href="#">
                            <i class="tim-icons icon-trash-simple mr-2"></i> Purge records
                          </a>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>

                  </template>
                </b-table>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-on:input="getMigrationData(perPage, getOffset())"
                ></b-pagination>
              </div>
            </div>
          </div>
          <div class="d-block d-sm-none">
            <div class="row" v-if="migration_log.length > 0">
              <div class="col">
                <b-table :items="migration_log"
                         :fields="['migration_logs']">
                  <template v-slot:cell(migration_logs)="row">
                    <div class="row">
                      <div class="col">
                        <p>{{row.item.first_name}} {{row.item.last_name}}
                          <i v-if="canCancel(row.item)" style="cursor: pointer" v-on:click="cancelRunPrompt(row.item)" class="tim-icons icon-simple-remove ml-2"></i>
                          <i v-if="!row.item.purged && !isRunning(row.item) && hasPermissions('migrations_delete')" style="cursor: pointer" v-on:click="deleteRecordsPrompt(row.item)" class="tim-icons icon-trash-simple ml-2"></i>
                        </p>
                      </div>
                      <div class="col text-right">
                        <badge>{{row.item.type}}</badge>
                        <badge :type="statusBadgeType(row.item)" class="ml-1">{{ statusLabel(row.item) }}</badge>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <small style="font-style: italic">
                          {{getLocalDate(row.item.timestamp)}}, {{getLocalTime(row.item.timestamp)}}
                        </small>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col">
                        <p>{{row.item.number_of_records}} records</p>
                      </div>
                    </div>
                  </template>
                </b-table>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-on:input="getMigrationData(perPage, getOffset())"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
  <base-alert-dialog
    :show="alertDialog.show"
    :title="alertDialog.title"
    :message="alertDialog.message"
    :variant="alertDialog.variant"
    @confirm="closeAlert"
    @cancel="closeAlert" />
  <base-alert-dialog
    :show="purgeDialog.show"
    title="Purge records?"
    :message="purgeMessage"
    variant="warning"
    show-cancel
    confirm-text="Purge"
    confirm-variant="danger"
    @confirm="confirmPurge"
    @cancel="closePurgeDialog" />
  <base-alert-dialog
    :show="cancelDialog.show"
    title="Cancel this run?"
    message="Rows already written stay in place. You can purge them from this log afterwards."
    variant="warning"
    show-cancel
    confirm-text="Cancel run"
    cancel-text="Keep running"
    confirm-variant="danger"
    @confirm="confirmCancelRun"
    @cancel="closeCancelDialog" />
</div>
</template>

<script>
import BreadcrumbItem from "@/components/Breadcrumb/BreadcrumbItem";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import { BTable, BPagination } from 'bootstrap-vue'
import {Auth} from "aws-amplify";
import {Dropdown, DropdownItem, DropdownMenu, Progress} from 'element-ui';
import {API_LOCATION} from "@/api-config";
import { BaseAlert } from '@/components';
import axios from "axios";
import countriesData from "@/assets/countries.json";
import Badge from "@/components/Badge";
import TabRail from "@/components/TabRail.vue";
import {dayOfWeek, formattedDate, time} from "@/plugins/dateFormatter";
import {formatGroupDate, formatGroupTime} from "@/plugins/dates";

export default {
  name: "Migration",
  components: {
    BreadcrumbItem,
    Breadcrumb,
    TabRail,
    BaseAlert,
    BTable,
    BPagination,
    Badge,
    [Progress.name]: Progress,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  computed: {
    filterSchema() {
      return [
        { key: 'type', type: 'select', label: 'Upload type', primary: true,
          options: (Array.isArray(this.migration_types) ? this.migration_types : []).map(t => ({ label: t.name, value: t.id })) },
        { key: 'status', type: 'select', label: 'Status', primary: true,
          options: [
            { label: 'Queued', value: 'queued' },
            { label: 'Running', value: 'running' },
            { label: 'Completed', value: 'completed' },
            { label: 'Cancelled', value: 'cancelled' },
            { label: 'Failed', value: 'failed' },
            { label: 'Purged', value: 'purged' }
          ] },
        { key: 'uploaded_by', type: 'text', label: 'Uploaded by', placeholder: 'Name', operatorLabel: 'contains', primary: true },
        { key: 'date', type: 'daterange', label: 'Date', primary: true }
      ]
    },
    purgeMessage() {
      if(this.purgeDialog.item && this.purgeDialog.item.type_id === 8){
        return 'Customer profiles updated by this batch will be restored to their previous values.'
      }
      return 'Imported records from this batch will be permanently deleted.'
    },
    categories() {
      return [
        { name: 'Import CSV', shortName: 'Import' },
        { name: 'Migration logs', shortName: 'Logs' }
      ];
    }
  },
  data(){
    return {
      polling: null,
      file: null,
      uploadUrl: '',
      time_format: JSON.parse(localStorage.getItem('group')).time_format,
      date_format: JSON.parse(localStorage.getItem('group')).date_format,
      loading: false,
      migration_types: [],
      migration_log: [],
      selectedMigrationType: '',
      activeTabIndex: 0,
      j:0,
      fields: '',
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      perPageOptions: [5, 10, 25, 50],
      errs: {
        type: ''
      },
      purgeDialog: { show: false, item: null },
      cancelDialog: { show: false, item: null },
      purgingIds: [],
      // Flat values for the shared <filter-bar>; applied server-side by get-migtrations-setup-data
      filterValues: {
        type: '',
        status: '',
        uploaded_by: '',
        date: { mode: 'range', days: '', from: '', to: '' }
      },
      alertDialog: { show: false, title: '', message: '', variant: 'info' },
      report_best_practices: [],
      migration_advice: [
        {id: 1, text: 'Recommended order of file uploads: 1. Customers (Global), 2.Transactions (By Group / Location), 3. Bookings (By Group / Location - needs to be associated to a transaction by an ID), ' +
            '4. Waivers (By Group / Location), 5. Gift cards, 6. Customer credit (Global), 7. Promo codes (By Group / Location)'},
        {id: 2, text: 'Make sure your headers match the ones provided. Use the copy tool to avoid typos.'},
        {id: 3, text: 'Headers marked with \'*\' are required.'},
        {id: 4, text: 'Make sure you have corresponding games created before uploading bookings or waivers and that the names match.'},
        {id: 5, text: 'Use Update customers to correct existing customer profiles by email, for example a wrong opt out setting. It never creates or deletes profiles.'},
     ]
    }
  },
  methods: {
    isOTC(){
      let user = JSON.parse(localStorage.getItem('profile')).email
      if(user == 'jana.geddis+7@gmail.com' || user == 'nick+demo@offthecouchgames.com'){
        return true
      }
      return false
    },
    async downloadErrorRecords(csv){
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'error_records.csv';
      anchor.click();
    },
    hasPermissions(scope){
      let permissions = JSON.parse(localStorage.getItem('permissions'))
      const matchFound = permissions.some(element => element === scope);
      return matchFound
    },
    statusLabel(item){
      if(item.purged){ return 'purged' }
      if(this.purgingIds.includes(item.id)){ return 'purging' }
      return item.status || 'completed'
    },
    statusBadgeType(item){
      const s = this.statusLabel(item)
      if(s === 'running' || s === 'queued' || s === 'purging'){ return 'info' }
      if(s === 'completed'){ return 'success' }
      if(s === 'cancelled'){ return 'warning' }
      return 'danger'
    },
    isRunning(item){
      return !item.purged && (item.status === 'queued' || item.status === 'running')
    },
    batchPercent(item){
      return item.batch_count ? Math.round((item.completed_batch_count / item.batch_count) * 100) : 0
    },
    isPurging(item){
      return !item.purged && this.purgingIds.includes(item.id)
    },
    startPolling(){
      if(this.polling){ clearInterval(this.polling) }
      this.polling = setInterval(() => this.getMigrationData(this.perPage, this.getOffset()), 4000);
    },
    // FilterBar change: apply the values, go back to page 1 and refetch. The
    // first change is FilterBar's saved-views resolution when the tab opens.
    onFiltersChanged(values){
      this.filterValues = {
        type: (values.type === '' || values.type == null) ? '' : values.type,
        status: values.status || '',
        uploaded_by: values.uploaded_by || '',
        date: { ...(values.date || { mode: 'range', days: '', from: '', to: '' }) }
      }
      this.currentPage = 1
      this.getMigrationData(this.perPage, 0)
    },
    computeDateRange(){
      const d = this.filterValues.date || {}
      let from = ''
      let to = ''
      if (d.mode === 'days' && d.days !== '' && d.days != null) {
        const today = new Date()
        const dt = new Date()
        dt.setDate(dt.getDate() - Number(d.days))
        from = dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2)
        to = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2)
      } else if (d.mode === 'range' && d.from && d.to) {
        from = d.from
        to = d.to
      }
      return { from, to }
    },
    filterQuery(){
      const f = this.filterValues
      const { from, to } = this.computeDateRange()
      return '&type=' + encodeURIComponent(f.type || '') +
        '&status=' + encodeURIComponent(f.status || '') +
        '&uploaded_by=' + encodeURIComponent(f.uploaded_by || '') +
        '&from=' + encodeURIComponent(from) +
        '&to=' + encodeURIComponent(to) +
        '&tz=' + encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone)
    },
    canCancel(item){
      return this.isRunning(item) && (this.hasPermissions('migrations_upload') || this.hasPermissions('migrations_delete'))
    },
    cancelRunPrompt(item){
      this.cancelDialog = { show: true, item: item }
    },
    closeCancelDialog(){
      this.cancelDialog = { show: false, item: null }
    },
    confirmCancelRun(){
      const item = this.cancelDialog.item
      this.closeCancelDialog()
      if(item){
        this.cancelRun(item)
      }
    },
    async cancelRun(item){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/migrations/' + item.id
      this.loading = true
      try {
        const response = await this.axios.put(url, { action: 'cancel' }, config)
        const result = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
        if(result && result.status && result.status !== 'cancelled'){
          this.showAlert('Import already finished', 'This import completed before the cancel reached it. Nothing was stopped.', 'info')
        } else {
          this.showAlert('Run cancelled', 'The import was stopped. Rows already written stay in the log until you purge them.', 'success')
        }
        this.getMigrationData(this.perPage, this.getOffset())
      } catch (err) {
        console.log(err)
        if(err.response && err.response.status === 401){
          this.$router.push('/forbidden')
          return
        }
        let message = 'The request could not be completed. Please try again.'
        try {
          const parsed = typeof err.response.data === 'string' ? JSON.parse(err.response.data) : err.response.data
          if(parsed && parsed.error){ message = parsed.error }
        } catch (e) { /* plain string body, keep the default */ }
        this.showAlert('Something went wrong', message, 'danger')
      } finally {
        this.loading = false
      }
    },
    showAlert(title, message, variant){
      this.alertDialog = { show: true, title: title, message: message, variant: variant }
    },
    closeAlert(){
      this.alertDialog.show = false
    },
    deleteRecordsPrompt(item){
      this.purgeDialog = { show: true, item: item }
    },
    closePurgeDialog(){
      this.purgeDialog = { show: false, item: null }
    },
    confirmPurge(){
      const item = this.purgeDialog.item
      this.closePurgeDialog()
      if(item){
        this.deleteRecords(item)
      }
    },
    getOffset(){
      return parseInt((this.currentPage * this.perPage) - this.perPage)
    },
    onPerPageChange(value){
      this.perPage = value
      this.currentPage = 1
      this.getMigrationData(this.perPage, this.getOffset())
    },
    csvCell(value){
      const text = value === null || value === undefined ? '' : String(value)
      return '"' + text.replace(/"/g, '""') + '"'
    },
    async downloadLogsCSV(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/migrations?count=200&offset=0' + this.filterQuery()
      this.loading = true
      try {
        const response = await this.axios.get(url, config)
        const rows = response.data.logs || []
        let csv = 'Type,Uploaded by,Date,Time,Total rows,Imported,Failed,Duplicates,Purged\n'
        for(const log of rows){
          csv += [
            log.type,
            log.first_name + ' ' + log.last_name,
            this.getLocalDate(log.timestamp),
            this.getLocalTime(log.timestamp),
            log.total_rows,
            log.number_of_records,
            log.failed_record_count || 0,
            log.duplicate_record_count || 0,
            log.purged ? 'Yes' : 'No'
          ].map(this.csvCell).join(',') + '\n'
        }
        const anchor = document.createElement('a')
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
        anchor.target = '_blank'
        anchor.download = 'migration_logs.csv'
        anchor.click()
      } catch (err) {
        console.log(err)
        this.showAlert('Something went wrong', 'The migration logs could not be downloaded. Please try again.', 'danger')
      } finally {
        this.loading = false
      }
    },
    async deleteRecords(item){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/migrations/' + item.id + '?type=' + item.type_id
      this.loading = true

      this.axios.delete(url, config)
        .then(response => {
          this.showAlert('Purge started', 'The records in this log are being purged. The log will show as purged once it finishes.', 'success')
          if(!this.purgingIds.includes(item.id)){ this.purgingIds.push(item.id) }
          this.getMigrationData(this.perPage, this.getOffset())
          this.startPolling()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlert('Something went wrong', 'The request could not be completed. Please try again.', 'danger')
          }
        })
    },
    viewRecords(item){
      this.$router.push({ path: '/settings/migration/log', query: { id: item.id, type: item.type_id }})
    },
    viewDuplicateRecords(item){
      this.$router.push({ path: '/settings/migration/log', query: { id: item.id, type: item.type_id, duplicates: 1 }})
    },
    getLocalTime(d){
      return formatGroupTime(d)
    },
    getLocalDate(d){
      return formatGroupDate(d)
    },
    getTime(d) {
      return time(this.time_format, d)
    },
    getDayOfWeek(d){
      if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
        return dayOfWeek(d) + ', '
      }
      return ''
    },
    getFormattedDate(d){
      if(d instanceof Date){
        d = d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate()
      }
      return formattedDate(this.date_format, d)
    },
    async getSignedURL (file) {
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let url = API_LOCATION + 'upload?bucket=2'

      let payload = {
        filePath: file.name,
        contentType: file.type + ';charset=utf-8'
      }
      const res = await axios.post(url, payload, config)
      return res.data
    },
    // Fails with an error (never hangs) so uploadFile can clear the loader
    async uploadFileToS3 (file, url) {
      let config = {
        headers: { 'Content-Type': file.type + ';charset=utf-8' },
        timeout: 120000
      }
      await axios.put(url, file, config)
    },
    async uploadFile(e) {
      const file = e.target.files[0]
      if(!file){ return }
      this.loading = true
      // Which step failed, for the alert and the console
      let step = 'prepare'
      try {
        this.uploadUrl = await this.getSignedURL(file)
        step = 'send'
        await this.uploadFileToS3(file, this.uploadUrl)
        step = 'import'
        let token = await this.getAuthToken()
        let config = {headers: {Authorization: token}}
        let companyId = localStorage.getItem('companyId')
        let companyGroupId = JSON.parse(localStorage.getItem('group')).id
        let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/migrations'
        let data = {
          file: this.uploadUrl.split("?")[0],
          type: this.selectedMigrationType.id
        }
        await axios.post(url, data, config)
        this.showAlert('File uploaded', 'The file is being imported. Migration logs show the progress and any rows that could not be imported.', 'success')
        this.switchTab(1)
      } catch (err) {
        console.error({ step: step, err: err })
        const status = err && err.response && err.response.status
        if(status === 401){
          this.$router.push('/forbidden')
        } else if(step === 'import' && err.response){
          this.showAlert('File rejected', String(err.response.data), 'danger')
        } else if(step === 'send'){
          this.showAlert('Upload failed', 'The file could not be sent. Please try again.', 'danger')
        } else {
          this.showAlert('Upload failed', 'The upload could not be started. Please try again.', 'danger')
        }
      } finally {
        this.loading = false
        // Re-keys the file input so the same file can be picked again
        this.j++
      }
    },
    setFields(){
      if(this.selectedMigrationType.id === 1){
        this.report_best_practices = [
          {id: 1, text: 'Email field is required. All other fields are optional.' },
          {id: 2, text: 'Email opt out field must be boolean, with values of either 1 and 0, or true and false.' },
          {id: 3, text: 'Photo opt out field must be boolean, with values of either 1 and 0, or true and false.' },
          {id: 4, text: 'Birthday, Date joined, and Date last visited fields must have the format \'YYYY-MM-DD\'.' },
          {id: 5, text: 'If Date joined and Date last visited fields are not included, they will be set to the date of import.' },
          {id: 6, text: 'Country field must be a 2-letter country code (ISO 3166-1 alpha-2). For example: US, CA, GB, AU, DE, NZ. Do not use full country names.', download: true },
          {id: 7, text: 'Tags field is a list of tag names separated by commas and wrapped in double quotes, for example "VIP, Birthday club". Tags that are not in this location\'s tag library yet are added to it. Each tag can be up to 100 characters. Tags are only added to new customer profiles, not to rows counted as duplicates.' }
        ]
        this.fields = "First name, Last name, Email<sup>*</sup>,\n" +
          "Birthday, Phone, Address line 1, Address line 2, City, State, Zip, Country, Email opt out, Photo opt out, Date joined, Date last visited, Notes, Tags"
      } else if (this.selectedMigrationType.id === 2){
        this.report_best_practices = [
          {id: 1, text: 'Email, Booking name, Booking start date, Booking start time and Booking end time fields are required. All other fields are optional.' },
          {id: 2, text: 'Birthday, Booking start date, and Booking end date fields must have the format \'YYYY-MM-DD\'.' },
          {id: 3, text: 'Date signed field must have the one following formats: \'YYYY-MM-DD HH:MM:SS\' or \'YYYY-MM-DD\' if you want to omit the exact time.' },
          {id: 4, text: 'Booking start time and Booking end time fields must have the format \'HH:MM:SS\'.' },
          {id: 5, text: 'Booking name field is the name of the game corresponding to the event. You must already have a game with the same name defined in Game Settings.' }
        ]
        this.fields = "First name, Last name, Email<sup>*</sup>,\n" +
          "Birthday, Phone, Date signed, Booking name<sup>*</sup>, " +
          "Booking start date<sup>*</sup>, Booking end date, Booking start time<sup>*</sup> Booking end time<sup>*</sup>"
      }
      else if (this.selectedMigrationType.id === 3){
        this.report_best_practices = [
          {id: 1, text: 'Booking name, Booking start date, Booking start time, Booking end time, and Status fields are required. All other fields are optional.' },
          {id: 2, text: 'Booking name field is the name of the game corresponding to the event. You must already have a game with the same name defined in Game Settings.' },
          {id: 3, text: 'Booking start date and Booking end date fields must have the format \'YYYY-MM-DD\'.' },
          {id: 4, text: 'Booking start time and Booking end time fields must have the format \'HH:MM:SS\'.' },
          {id: 5, text: 'Status field must be one of the following values: available, booked, cancelled, blocked, call_to_book.' },
          {id: 6, text: 'Order number field is the ID of the corresponding transaction, if applicable.' },
          {id: 7, text: 'Reservation type takes values \'public\' for public bookings and \'private\' for private bookings. Public bookings will not be checked for duplicates.' }
        ]
        this.fields = "Booking name<sup>*</sup>, " +
          "Booking start date<sup>*</sup>, Booking end date, Booking start time<sup>*</sup>, Booking end time<sup>*</sup>, " +
          "Group size, Price, Status<sup>*</sup>, Order number, Notes, Reservation type"
      }
      else if (this.selectedMigrationType.id === 4){
        this.report_best_practices = [
          {id: 1, text: 'Email and Order number fields are required. All other fields are optional.' },
          {id: 2, text: 'Email, First name, and Last name fields correspond to the customer linked to the transaction.' },
          {id: 3, text: 'Transaction date field must have the one following formats: \'YYYY-MM-DD HH:MM:SS\' or \'YYYY-MM-DD\' if you want to omit time.' },
          {id: 4, text: 'Transaction status field must have one of the following values: active or cancelled.' },
          {id: 5, text: 'Order number field is the ID of the corresponding transaction, if applicable.' },
        ]
        this.fields = "First name, Last name, Email<sup>*</sup>, Phone, Transaction date, Transaction status, Order number<sup>*</sup>, Price, " +
          "Total, Paid, Due, Taxes, Fees, Discount, Refunded, Notes"
      }
      else if (this.selectedMigrationType.id === 5){
        this.report_best_practices = [
          {id: 1, text: 'Promo name, Redemption type, and Value amount fields are required. All other fields are optional.' },
          {id: 2, text: 'Redemption type field must be one of the following values: value, percentage.'},
          {id: 3, text: '"Applicable to gift cards and merchandise" field must be true or false.'},
          {id: 4, text: 'To set Unlimited quantity on a promo code, set the value of the Quantity column to -1.'},
          {id: 5, text: 'Promo code group field is optional and links promo codes to an existing promo code template by name.'}
        ]
        this.fields = "Promo name<sup>*</sup>, Description, Redemption type<sup>*</sup>, " +
          "Value amount<sup>*</sup>, Quantity, Number of times used, Applicable to gift cards and merchandise, Promo code group"
      }
      else if (this.selectedMigrationType.id === 6){
        this.report_best_practices = [
          {id: 1, text: 'Gift card code, Total value, Spent, Customer email, and Recipient email fields are required. All other fields are optional.' },
          {id: 2, text: 'Date purchased, Expiration date, and Delivery date fields must have the format \'YYYY-MM-DD\'.' },
          {id: 3, text: 'Order number will link the gift card as a purchase under an existing transaction.' },
          {id: 4, text: 'Status field must be one of the following values: active or deactivated. When no status field is included, records will be active by default.' }
        ]
        this.fields = "Gift card code<sup>*</sup>, Personal message, Date purchased, Delivery date, Expiration date, Status, Total value<sup>*</sup>, " +
          "Spent<sup>*</sup>, Order number, Customer first name, Customer last name, Customer email<sup>*</sup>, Recipient email <sup>*</sup>, Recipient first name, Recipient last name"
      } else if (this.selectedMigrationType.id === 7){
        this.report_best_practices = [
          {id: 1, text: 'Email and Total value fields are required. All other fields are optional.' },
          {id: 2, text: 'Email, First name, and Last name fields correspond to the customer who received customer credit.' }
        ]
        this.fields = "First name, Last name, Email<sup>*</sup>, Total value<sup>*</sup>, Remaining, Spent"
      } else if (this.selectedMigrationType.id === 8){
        this.report_best_practices = [
          {id: 1, text: 'Email field is required and is used to find the existing customer profile. Rows whose email does not match exactly one customer profile are listed in the error records.' },
          {id: 2, text: 'Only the columns included in the file are updated. Leave a cell blank to keep the current value.' },
          {id: 3, text: 'Email opt out and Photo opt out fields must be boolean, with values of either 1 and 0, or true and false.' },
          {id: 4, text: 'Birthday, Date joined, and Date last visited fields must have the format \'YYYY-MM-DD\'.' },
          {id: 5, text: 'Country field must be a 2-letter country code (ISO 3166-1 alpha-2). For example: US, CA, GB, AU, DE, NZ. Do not use full country names.', download: true },
          {id: 6, text: 'Only customer profiles created by a Customers import are updated. Profiles created organically are skipped and listed in the error records.' },
          {id: 7, text: 'No customer profiles are created or deleted. Purging the log restores every updated profile to its previous values.' }
        ]
        this.fields = "Email<sup>*</sup>, First name, Last name, Birthday, Phone, Address line 1, Address line 2, City, State, Zip, Country, " +
          "Email opt out, Photo opt out, Date joined, Date last visited"
      }
    },
    copy(){
      navigator.clipboard.writeText(this.fields);
    },
    downloadCountryCodes(){
      let csv = 'Country,Code\n'
      for (let c of countriesData.countries) {
        csv += c.name + ',' + c.code + '\n'
      }
      const anchor = document.createElement('a')
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
      anchor.target = '_blank'
      anchor.download = 'country_codes.csv'
      anchor.click()
    },
    switchTab(index){
      this.activeTabIndex = index
      if(this.activeTabIndex === 1){
        this.getMigrationData(this.perPage, this.getOffset())
        this.startPolling()
        // for(let n in this.migration_log){
        //   if(!this.migration_log[n].purged && this.migration_log[n].total_rows > this.migration_log[n].number_of_records){
        //     this.polling = setInterval(this.getMigrationData, 500);
        //     return
        //   }
        // }
      } else {
        clearInterval(this.polling);
        this.polling = null
      }
      this.j++
    },
    async getAuthToken() {
      const session = await Auth.currentSession()
      return session.idToken.jwtToken
    },
    async getMigrationData(count, offset){
      if(count && offset){
        this.loading = true
      }
      if(!count){
        count = this.perPage
      }
      if(!offset){
        offset = 0
      }
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' +
        companyGroupId + '/migrations?count=' + count + '&offset=' + offset + this.filterQuery()

      this.axios.get(url, config)
        .then(response => {
          this.migration_types = response.data.migration_types
          this.migration_log = response.data.logs
          this.totalRows = response.data.total_rows
          this.purgingIds = this.purgingIds.filter(id => {
            const log = this.migration_log.find(l => l.id === id)
            return log && !log.purged
          })
          const anyRunning = this.migration_log.some(log => this.isRunning(log) || this.isPurging(log))
          if(!anyRunning){
            clearInterval(this.polling);
            this.polling = null
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showAlert('Something went wrong', 'The request could not be completed. Please try again.', 'danger')
          }
        })
    },
  },
  mounted() {
    // A saved view link from the views drawer carries ?view=; the filter bar
    // lives on the logs tab, so open there. switchTab fetches and starts polling.
    if(this.$route && this.$route.query && this.$route.query.view){
      this.switchTab(1)
    } else {
      this.getMigrationData(this.perPage, 0)
    }
  },
  beforeDestroy() {
    // Clear the interval when the component is destroyed
    clearInterval(this.polling);
  },
}
</script>

<style scoped>

</style>
